import type { VariantDef } from '../types';
import {
  UPPER_IDS,
  chance,
  classicFullHouse,
  classicLargeStraight,
  classicSmallStraight,
  fiveKindCategory,
  ofAKindAll,
  thresholdBonus,
  upperCategories,
} from './shared';

export const CLASSIC_RULES = [
  'Roll up to three times a turn, holding any dice between rolls.',
  'Score each roll in exactly one open box. Thirteen boxes, thirteen turns.',
  'Upper section: 63 or more (three of each number) earns a 35-point bonus.',
  'A Yahtzee is five of a kind: all five dice showing the same number. It scores 50, and each additional Yahtzee earns 100 if the box already holds 50.',
  'Joker: a later Yahtzee must go in its upper box if open, otherwise any lower box counts in full.',
];

export const classicCategories = () => [
  ...upperCategories(),
  ofAKindAll('threeKind', 'Three of a Kind', '3K', 3),
  ofAKindAll('fourKind', 'Four of a Kind', '4K', 4),
  classicFullHouse,
  classicSmallStraight,
  classicLargeStraight,
  fiveKindCategory('yahtzee', 'Yahtzee', 'Y!', 50),
  chance,
];

export const classic: VariantDef = {
  id: 'classic',
  name: 'Classic',
  tagline: 'The one you know',
  description:
    'Five dice, three rolls, thirteen boxes. A Yahtzee is five of a kind: all five dice showing the same number. The 1956 original with Hasbro joker rules.',
  family: 'official',
  diceCount: 5,
  maxRolls: 3,
  columns: [1],
  categories: classicCategories(),
  upperCategoryIds: UPPER_IDS,
  upperBonus: thresholdBonus(63, 35),
  upperBonusHint: '35 points at 63 or more',
  fiveKind: { categoryId: 'yahtzee', bonus: 100, joker: true },
  sharedRolls: false,
  sequential: false,
  streak: null,
  powers: null,
  letterFaces: null,
  pipColors: null,
  servedInstantWin: null,
  rules: CLASSIC_RULES,
};
